/**
 * websocket
 */

let websocket: any; // 用于存储实例化后websocket
let isConnect = false; // 连接标识 避免重复连接
let rec: any; // 断线重连定时器
let heartbeatTimer: any; // 心跳定时器
let heartbeatTimeoutTimer: any; // 心跳超时定时器
let totalUserId:any //用户id

// 存储重连信息的键名
const RETRY_STORAGE_KEY = 'websocket_retry_info';

import { message, notification } from 'antd';
import * as crypto from 'crypto';
import { PushMessageIcon } from '../../compnents/icons/Icons';
import React from 'react'

// 获取当天日期字符串（用于判断是否过期）
function getTodayString(): string {
    return new Date().toISOString().split('T')[0];
}

// 获取存储的重试信息
function getRetryInfo(): { count: number; date: string } {
    const stored = localStorage.getItem(RETRY_STORAGE_KEY);
    if (stored) {
        try {
            const info = JSON.parse(stored);
            // 检查是否是当天的记录
            if (info.date === getTodayString()) {
                return info;
            }
        } catch (e) {
            console.error('Failed to parse retry info', e);
        }
    }
    // 默认值或过期返回新记录
    return { count: 0, date: getTodayString() };
}

// 保存重试信息
function saveRetryInfo(count: number): void {
    const info = {
        count,
        date: getTodayString()
    };
    localStorage.setItem(RETRY_STORAGE_KEY, JSON.stringify(info));
}


// 创建websocket
function createWebSocket() {
    console.log("websocket初始化完成");
    
    if (window.WebSocket) {
        console.log("WebSocket 受支持");
    } else {
        console.log('当前浏览器版本过旧可能无法接收消息，请尝试更换浏览器');
        return;
    }

    try {
        initWebSocket(); // 初始化websocket连接
    } catch (e) {
        console.log("尝试创建连接失败");
        reConnect(); //重试
    }
}

// 初始化websocket
function initWebSocket() {
    // 寻找当前账户,拼接连接地址
    const credentialsString = localStorage.getItem('credentials');
    if (credentialsString !== null) {
        const credentials = JSON.parse(credentialsString);
        const userId = credentials.userId;
        if (!userId || userId <= 0) {
            return;
        }
        totalUserId = userId;

        //拼装用户id
        let originalParams = userId;
        //拼装时间
        const currentTimeStamp = Date.now();
        originalParams = userId + "_" + currentTimeStamp;
        const encryptedWithIV = doEncrypt(originalParams)
        let wsUrl = "";
        const protocol = document.location.protocol;

        if (protocol.indexOf("https") >= 0) {
            // 使用固定域名 message.hydhis.cn
            wsUrl = "wss://message.hydhis.cn/ws2";
        } else {
            // 直连IP 47.99.101.185
            wsUrl = "ws://47.99.101.185:8202/wsServer";
        }
        // wsUrl  = "ws://127.0.0.1:8202/wsServer";
        // wsUrl = "wss://his.develop.hydhis.com/ws2";

        // const url = window.location.host;
        // if (protocol.indexOf("https")>=0) {
        //     wsUrl = "wss://"+url+"/ws2";
        // }else{
        //     wsUrl = "ws://"+url+"/ws2";
        // }
        // wsUrl  = "ws://127.0.0.1:8202/wsServer";
        // wsUrl = "wss://his.develop.hydhis.com/ws2";

        websocket = new WebSocket(wsUrl + "?" + encryptedWithIV);
    } else {
        return;
    }

    websocket.onopen = function (e: any) {
        websocketOpen(e);
    };

    // 接收
    websocket.onmessage = function (e: any) {
        websocketonmessage(e);
    };

    // 连接发生错误
    websocket.onerror = function () {
        console.log("WebSocket连接发生错误");
        isConnect = false; // 连接断开修改标识
        reConnect(); // 重连
    };

    websocket.onclose = function (e: any) {
        websocketclose(e);
    };
}

// 重连
const reConnect = () => {
    if (isConnect) return;
    
    const retryInfo = getRetryInfo();
    const retryCount = retryInfo.count;

    if(retryCount >= 30){
        console.log("重试次数过多，不再尝试建立连接");
        return;
    }
    
    // 清除之前的定时器
    rec && clearTimeout(rec);


    // // 指数退避算法：延迟时间 = 基础延迟 * (2^重试次数)
    // const baseDelay = 1000; // 基础延迟1秒
    // const delay = baseDelay * Math.pow(3, retryCount); 

    // 改为固定间隔重连：每分钟一次
    const delay = 60 * 1000; // 60秒 = 1分钟
    
    console.log(`第${retryCount + 1}次尝试重连，等待${delay/1000}秒`);
    
    rec = setTimeout(() => {
        // 更新重试次数
        saveRetryInfo(retryCount + 1);
        createWebSocket();
    }, delay);
};

// 连接成功
function websocketOpen(e: any) {
    console.log("已建立连接");
    isConnect = true;
    // 每 25 秒发送一次心跳消息
    heartbeatTimer = setInterval(() => {
        const heartbeatMessage = { code:103,socketId:totalUserId, buildTimestamp: Date.now(),msg:"" };
        const heartbeat =  JSON.stringify(heartbeatMessage)
        websocketsend(doEncrypt(heartbeat));
        
        // 设置心跳超时检测，30秒内没有收到响应则认为连接已失效
        startHeartbeatTimeout();
    }, 25000);
}

// 启动心跳超时检测
function startHeartbeatTimeout() {
    // 清除之前的超时定时器
    if (heartbeatTimeoutTimer) {
        clearTimeout(heartbeatTimeoutTimer);
    }
    
    // 设置新的超时定时器，30秒后检查连接状态
    heartbeatTimeoutTimer = setTimeout(() => {
        console.log("心跳超时，检查连接状态");
        // 如果连接标识为true但实际连接可能已失效，强制关闭并触发重连
        if (isConnect && websocket && websocket.readyState === WebSocket.OPEN) {
            console.log("检测到心跳超时，尝试重新建立连接");
            websocket.close();
        }
    }, 30000); // 30秒超时时间
}

function websocketonmessage(e: any) {
    // 收到任何消息都表示连接正常，重置心跳超时定时器
    if (heartbeatTimeoutTimer) {
        clearTimeout(heartbeatTimeoutTimer);
    }
    
    let message;
    try {
        message = JSON.parse(deEncrypt(e.data));
        if (message.code === 201) {
        notification.info({ 
            message: message.msg,
            className:'pushMessage',
            icon: React.createElement(PushMessageIcon, { style: { position: 'relative'} })
        })
    }
    } catch (error) {
        console.error('消息解析失败:', error);
        return;
    }
}
/**
 * 消息加密函数
 * @param originalParams 明文内容
 * @returns 密文内容
 */
function doEncrypt(
  originalParams: string,
): string {
  const iv = crypto.randomBytes(16);
  const ivString = iv.toString('hex');
  try {
    const secretKey = generateSecretKey(ivString);
    const cipher = crypto.createCipheriv(
      'aes-128-cbc',
      Buffer.from(secretKey),
      iv
    );
    let encrypted = cipher.update(originalParams, 'utf8', 'hex');
    encrypted += cipher.final('hex');
    return encrypted + ivString;
  } catch (error) {
    return ''
  }
}

/**
 * 消息解密函数
 * @param originalParams 密文内容
 * @returns 明文内容
 */
function deEncrypt(
    originalParams: string,
): string {
    const realParams = originalParams.substring(0, originalParams.length - 32)
    const ivHex   = originalParams.substring(originalParams.length - 32)
    try {
        const secretKey = generateSecretKey(ivHex);
        const iv = Buffer.from(ivHex, 'hex');
        const decipher = crypto.createDecipheriv('aes-128-cbc', Buffer.from(secretKey), iv);
        let decrypted = decipher.update(realParams, 'hex', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted;
    } catch (error) {
        return ''
    }
}



// 数据发送
function websocketsend(data: any) {
    if (websocket && websocket.readyState === WebSocket.OPEN) {
        websocket.send(data);
    } else {
        console.log("WebSocket未连接，无法发送消息");
    }
}

// // 发送消息
// function sendWebSocket(data: any) {
//   if (websocket.readyState === websocket.OPEN) { // 开启状态
//     websocketsend(data);
//   } else { // 若 未开启 / 正在开启 状态 ，则等待1s后重新调用
//     setTimeout(function () {
//       sendWebSocket(data);
//     }, 1000);
//   }
// }


// 关闭
function websocketclose(e: any) {
    console.log(e);
    isConnect = false; // 断开后修改标识
    console.log("connection closed (" + e.code + ")");
    // 清除所有定时器
    clearAllTimers();
    reConnect(); // 连接关闭时触发重连
}

// 清除所有定时器
function clearAllTimers() {
    // 清除心跳定时器
    if (heartbeatTimer) {
        clearInterval(heartbeatTimer);
        heartbeatTimer = null;
    }
    // 清除心跳超时定时器
    if (heartbeatTimeoutTimer) {
        clearTimeout(heartbeatTimeoutTimer);
        heartbeatTimeoutTimer = null;
    }
    // 清除重连定时器
    if (rec) {
        clearTimeout(rec);
        rec = null;
    }
}

// 关闭连接
const closeWebSocket = () => {
    // 清除所有定时器，防止在关闭过程中触发回调
    clearAllTimers();
    if (websocket) {
        websocket.close();
    }
};

function generateSecretKey(vi: string): string {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10).replace(/-/g, "");
    const input = formattedDate + vi;
    // 通过SHA-256哈希函数生成密钥
    const hash = crypto.createHash('sha256').update(input).digest('hex');
    return hash.slice(0, 16); // 截取前16个字符
}

export {
    createWebSocket,
    closeWebSocket,
};